<template>
  <common-dialog ref="dialog" width="80%" title="打印快递单" :confirm-on-close-change="false" @closed="onClosed">
    <template slot="form">
      <el-row>
        <el-col :span="8">
          <el-form-item label="选择打印机">
            <el-select v-model="data.printer" placeholder="请选择" clearable>
              <el-option v-for="(i, k) in printerList" :key="k" :label="i.name" :value="i.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="data.rows" border class="merge-table" max-height="500">
            <el-table-column prop="date" label="收货地址" min-width="350">
              <template slot-scope="{row}">
                <div class="merge-item">
                  <span>{{ row.receiverName }}，{{ row.receiverPhone }}，</span>
                  <span>{{ row.province || '' }}{{ row.city || '' }}{{ row.district || '' }}{{ row.town || '' }}</span>
                  <span>{{ row.address || '' }}</span>
                </div>
                <!-- <div class="merge-item" v-if="row.Id!=2">周**，17****199，江苏省苏州市吴中区江苏省苏*******建工恒泰项目部</div>
                <div class="merge-item" v-else>
                  <div class="badge badge-merge">合单4</div>
                  <span>陈**, 172*****406，江苏省/南通市/如东县/双逸创业园区******</span>
                </div> -->
              </template>
            </el-table-column>
            <el-table-column prop="name" label="订单号" width="200">
              <template slot-scope="{row}">
                <div class="merge-item">{{ row.orderSn }}</div>
                <!-- <template v-if="row.Id == 2">
                  <div class="merge-item">240318-529897952651816</div>
                  <div class="merge-item">240318-529897952651000</div>
                  <div class="merge-item">240318-529897952651111</div>
                </template> -->
                <!-- <template v-else>
                  <div class="merge-item">240316-535486831503318</div>
                </template> -->
              </template>
            </el-table-column>
            <el-table-column prop="Field8" label="运单号" width="200">
              <div slot-scope="{row}" class="merge-item">
                <span>{{ row.expressNumber || '无' }}</span>
                <!-- <template v-if="row.Field8 && row.Field8.length > 0">
                  <div v-for="(i1, k1) in row.Field8" :key="k1">
                    <div>{{ i1.Field8_1 }}：</div>
                    <div v-for="(i2, k2) in i1.Field8_2" :key="k2">{{ i2.Field8_2_1 }}</div>
                  </div>
                </template>
                <span v-else>无</span> -->
              </div>
            </el-table-column>
            <el-table-column prop="address" label="打印状态" width="90">
              <div slot-scope="{row}" class="merge-item">已打印</div>
            </el-table-column>
            <el-table-column prop="address" label="发货状态" width="90">
              <template slot-scope="{row}">
                <div class="merge-item">已发货</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="90">
              <template slot-scope="{row}">
                <el-button type="text" @click="onPrintAfresh(row)">重新打印</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </template>
    <template slot="footer">
      <el-button type="primary" @click="onBatchPrintAfresh()">批量重新打印</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import { nanoid } from 'nanoid';
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      // api: require('@/api/wx/malladdresses').default,
      orderApi: require('@/api/wx/order').default,
      malladdressesApi: require('@/api/wx/malladdresses').default,
      socket: null,
      data: {
        id: 0,
        isPrint: 0, //0：未打印，1：已打印，2：已锁定
        printer: "", //打印机
        separate: false, //拆单
        separateNumber: 2,
        surplusCount: 0, //剩余单数
        printCount: 0, //申请打印数
        autoSend: false, //自动发货
        address: "", //默认发货地址
        rows: []
      },
      //打印数据
      requestId: nanoid(10),
      printerList: [],
      printData: [],
      preview: false
    };
  },
  mounted() { },
  methods: {
    setData(data) {
      console.log("setData", data);
      this.data.printCount = data.rows.length;
      this.data.isPrint = data.isPrint;
      this.data.autoSend = data.autoSend;
      this.data.rows = data.rows;
      this.onInitWs();
    },
    //初始化websocket (要打开pdd打印组件，websocket才能连接上)
    onInitWs() {
      this.socket = new WebSocket("ws://127.0.0.1:13528"); // Ali
      // this.socket = new WebSocket("ws://127.0.0.1:5000"); // Pdd
      // 添加WebSocket事件监听器
      this.socket.addEventListener("open", this.onSocketOpen);
      this.socket.addEventListener("message", this.onSocketMessage);
      this.socket.addEventListener("close", this.onSocketClose);
      this.socket.addEventListener("error", this.onSocketError);
      // console.log("初始化", this.socket);
    },
    onSocketOpen() {
      console.log("WebSocket连接已打开");
      //获取本地打印机列表
      let data = {
        cmd: "getPrinters",
        requestID: "123458976",
        version: "1.0",
      };
      this.socket.send(JSON.stringify(data));
    },
    onSocketMessage(event) {
      const result = JSON.parse(event.data);
      console.log("收到WebSocket消息:", result);
      if (result.previewImage) {
        result.previewImage.forEach(x => console.log("image:", x))
      }
      // console.log(result.cmd);
      if (result.cmd == "getPrinters") {
        this.printerList = result.printers;
      }
      // if (result.cmd == "print") {
      //   console.log("打印信息");
      // }
      if (result.cmd == "print") {
        console.log("打印结果通知");
        if (result.taskStatus == "failed") {
          this.$message.error("打印失败");
        } else {
          this.$message.success("打印成功");
          this.close();
        }
        // if (result.taskStatus == "success") {
        //   this.$message.success("打印成功");
        // }
      }
      // if (result.cmd == "PrintResultNotify") {
      //   console.log("打印结果通知");
      //   this.socket.close();
      // }
    },
    onSocketClose() {
      console.log("WebSocket连接已关闭");
    },
    onSocketError(event) {
      console.error("WebSocket连接错误:", event);
    },
    onPrintAfresh(row) {
      if (!row.expressNumber) {
        this.$message.error("当前无运单号，请重新取号打印");
        return;
      }
      console.log("重新打印", row);
      this.onBatchPrintAfresh(row);
    },
    onBatchPrintAfresh(row = null) {
      console.log("批量重新打印");
      if (!this.data.printer) {
        this.$message.warning("请选择打印机")
        return;
      }

      var rows = [];
      if (row == null) {
        rows = this.data.rows;
      } else {
        rows = [row];
      }

      console.log("rows", rows)

      var ids = rows.map(x => x.id);

      this.orderApi.print({ ids, addressId: 1, orderType: 0 }).then(data => {
        this.$emit("reload");
        this.startPrint(data);
      })
    },
    startPrint(rows) {
      var data = {
        cmd: "print",
        requestID: this.requestId,
        version: "1.0",
        task: {
          taskID: new Date().getTime().toString(),
          preview: this.preview,
          previewType: "image",
          printer: this.data.printer,
          documents: [],
        }
      }

      var docs = [];

      rows.forEach(x => {
        var printData = JSON.parse(x.print_data);
        console.log("printData", printData);
        docs.push({
          documentID: x.waybill_code,
          contents: [
            {
              data: { ...printData.data },
              signature: printData.signature,
              templateURL: printData.templateURL,
              ver: printData.ver
            },
            // {
            //   data: {
            //     value: "测试字段值需要配合自定义区变量名"
            //   },
            //   templateURL: "http://cloudprint.cainiao.com/template/customArea/440439"
            // }
          ]
        })
      })

      data.task.documents = docs;
      console.log("开始打印", data);
      this.socket.send(JSON.stringify(data));
    },
    onClosed() {
      if (this.socket) this.socket.close();
    }
  },
};
</script>